import type { Configuration, PopupRequest } from '@azure/msal-browser';

const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

// When an app requests a token for itself, Entra rejects the `api://{clientId}`
// URI form (AADSTS90009) and requires the GUID form `{clientId}/.default`.
// The gateway accepts both audience styles, so this still validates server-side.
export const apiLoginRequest: PopupRequest = {
  scopes: [`${clientId}/.default`],
};

export const interactiveScopes = [`${clientId}/.default`];
